/**
 * @generated SignedSource<<0d73482dd8c538b9f5961e7ea30bf156>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StartContentNodeInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type useCardAdvanceTreeNavigation_StartContentNodeMutation$variables = {
  input: StartContentNodeInput;
};
export type useCardAdvanceTreeNavigation_StartContentNodeMutation$data = {
  readonly LearnV2: {
    readonly startContentNode: {
      readonly contentSubmission: {
        readonly id: string;
      };
    } | null;
  };
};
export type useCardAdvanceTreeNavigation_StartContentNodeMutation = {
  response: useCardAdvanceTreeNavigation_StartContentNodeMutation$data;
  variables: useCardAdvanceTreeNavigation_StartContentNodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Mutations",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "StartContentNodePayload",
        "kind": "LinkedField",
        "name": "startContentNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentSubmission",
            "kind": "LinkedField",
            "name": "contentSubmission",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCardAdvanceTreeNavigation_StartContentNodeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCardAdvanceTreeNavigation_StartContentNodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8777213e9e1cdca94d74cdd30bbc420c",
    "id": null,
    "metadata": {},
    "name": "useCardAdvanceTreeNavigation_StartContentNodeMutation",
    "operationKind": "mutation",
    "text": "mutation useCardAdvanceTreeNavigation_StartContentNodeMutation(\n  $input: StartContentNodeInput!\n) {\n  LearnV2 {\n    startContentNode(input: $input) {\n      contentSubmission {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b0a1e9dd2258d31c0718c4139d794ab";

export default node;
